import type { WorkspaceKey } from '@festina-life/api'
import { Alert, CircularSpinner } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Suspense } from 'react'

import { useConciseBranch } from '../../../uiModels/branches/useConciseBranch'
import { OperationsProvider } from '../../../workspace/OperationsProvider'
import { DetailsPanel } from '../../detailsPanel/DetailsPanel'
import { WorkspaceName } from '../../workspaceName/WorkspaceName'
import { WorkspaceLoadingStatus } from '../workspacesTree/WorkspaceLoadingStatus'
import { WorkspaceDetailsTabs } from './WorkspaceDetailsTabs'

type Props = {
  workspaceKey: WorkspaceKey
  onClose: () => void
}

export const WorkspaceDetailsPanel = ({ onClose, workspaceKey }: Props) => {
  const translate = useTranslate()
  const branchKey = workspaceKey.branchKey

  const workspaceBranch = useConciseBranch({
    branchName: branchKey.name,
    server: branchKey.server,
    shouldFallbackToStandard: false,
  })

  return (
    <Suspense
      fallback={
        <div className="size-full flex items-center justify-center">
          <CircularSpinner />
        </div>
      }
    >
      <OperationsProvider
        workspaceKey={workspaceKey}
        branchKey={workspaceKey.branchKey}
        isDisabledChangesetsRelevant={false}
      >
        <DetailsPanel
          onClose={onClose}
          header={
            <>
              <span className="text-gray-500 dark:text-gray-400">
                {branchKey.server}
              </span>
              <WorkspaceName isShowingIcon workspaceKey={workspaceKey} />
            </>
          }
          status={<WorkspaceLoadingStatus />}
        >
          {!workspaceBranch && (
            <Alert
              severity="error"
              title={translate('workspaceDetailsPanel.inexistentBranch', {
                branchName: branchKey.name,
                server: branchKey.server,
              })}
            />
          )}
          <WorkspaceDetailsTabs />
        </DetailsPanel>
      </OperationsProvider>
    </Suspense>
  )
}
